import styled from "styled-components";

const MainContainer = styled.div`
  background-color: #fafdf3;
`;

function ProfilePage() {
  return <MainContainer>Profile Page</MainContainer>;
}

export default ProfilePage;
